import { useTranslation } from "next-i18next";
import { useMemo } from "react";

export type CargillCountry = {
  countryEnglishKey: string;
  translatedCountry: string;
};

/**
 * Gets countries list based on translations, not specifically sorted.
 * @returns a list of businesses
 */
export function useCargillDefaultCountries() {
  const { t, i18n } = useTranslation();
  const data = useMemo(() => {
    const list = t("request_access:more_information.countries_list");
    const json = JSON.parse(list) as CargillCountry[];
    return json;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, t]);

  return data;
}
